import { Injectable } from "@angular/core";
import { customConfig } from "../../../custom/custom-config";
import { WebshopSettingsDataModel2, WebshopSettingsDMKey } from "../../shared/models";
import { ContentType } from "../../shared/contentTypes";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";

@Injectable()
export class CookiePolicyService {

  constructor(private _objObsInjectHelper: CircularInjectionHelper) { }

  private async GetWebshopSettingsDataModel2(): Promise<WebshopSettingsDataModel2> {
    const me = this;
    const webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, me._objObsInjectHelper);
    return await webshopSettingsObsServ.GetObject(WebshopSettingsDMKey);
  }

  /** Ermittelt ob Adyen benutzt wird */
  public async IsAdyenActive(): Promise<boolean> {
    const me = this;
    const webSettings = await me.GetWebshopSettingsDataModel2();
    return webSettings.has_adyen;
  }

  /** Ermittelt ob Adyen GooglePay(paywithgoogle) benutzt wird */
  public async IsGooglePayAvailable(): Promise<boolean> {
    const me = this;
    const webSettings = await me.GetWebshopSettingsDataModel2();
    return webSettings.googlePayActive;
  }

  /** Ermittelt ob Wallee benutzt wird */
  public async IsWalleeActive(): Promise<boolean> {
    const me = this;
    const webSettings = await me.GetWebshopSettingsDataModel2();
    return webSettings.has_wallee;
  }

  /**
   *  Ermittelt ob Meta Pixel benutzt wird
   *  -> wird in den custom configs gesetzt
   */
  public IsMetaActive(): boolean {
    const me = this;
    return customConfig.meta_pixel !== "";
  }

  /**
   *  Ermittelt ob Chef Camapigns benutzt wird
   *  -> wird in den custom configs gesetzt
   */
  public IsChefCampaignsActive(): boolean {
    const me = this;
    return customConfig.chef_campaigns_cid !== "";
  }
}